import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const BlogContent = styled.div`
  .blog-content {
    margin: 1rem 0;
    line-height: 1.6;
    
    img {
      max-width: 100%;
      height: auto;
      margin: 1rem 0;
    }

    p {
      margin-bottom: 1rem;
    }

    h1, h2, h3, h4, h5, h6 {
      margin: 1.5rem 0 1rem;
    }
  }
`;

const BlogPages = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`;

const PageItem = styled.article`
  margin-bottom: 3rem;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  h2 {
    color: #4a1a99;
    margin-bottom: 1rem;
  }

  .publish-date {
    color: #666;
    font-style: italic;
    margin-bottom: 1.5rem;
  }
`;

const ContentPreview = styled.div`
  margin-bottom: 1rem;
  max-height: 200px;
  overflow: hidden;
  position: relative;

  &.expanded {
    max-height: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(transparent, white);
    pointer-events: none;
  }

  &.expanded::after {
    display: none;
  }
`;

const ReadMoreButton = styled.button`
  display: inline-block;
  margin-top: 1rem;
  color: #6633cc;
  text-decoration: none;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

const BlogContainer = () => {
  const [pages, setPages] = useState([]);
  const [expandedPages, setExpandedPages] = useState({});
  const blogId = '1555415857002703612';
  const apiKey = 'AIzaSyBCuUWquNrat7XA0oeYfexifEjP5V7wRGE';

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/blogger/v3/blogs/${blogId}/pages?key=${apiKey}`
        );
        if (response.data && response.data.items) {
          setPages(response.data.items);
        }
      } catch (error) {
        console.error('Error fetching pages:', error);
      }
    };
    fetchPages();
  }, []);

  const toggleExpand = (pageId) => {
    setExpandedPages(prev => ({
      ...prev,
      [pageId]: !prev[pageId]
    }));
  };

  return (
    <BlogPages>
      {pages.map((page) => (
        <PageItem key={page.id}>
          <h2>{page.title}</h2>
          <p className="publish-date">
            Publicado: {new Date(page.published).toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </p>
          <ContentPreview 
            className={expandedPages[page.id] ? 'expanded' : ''}
          >
            <BlogContent 
              dangerouslySetInnerHTML={{ __html: page.content }} 
              className="blog-content"
            />
          </ContentPreview>
          <ReadMoreButton 
            onClick={() => toggleExpand(page.id)}
          >
            {expandedPages[page.id] ? 'Mostrar menos' : 'Leer más →'}
          </ReadMoreButton>
        </PageItem>
      ))}
    </BlogPages>
  );
};

export default BlogContainer;
